import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Key = ({
  size,
  type,
  theme,
  className,
  dataTestId = "key-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M4.001 12.667a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Z" />
    <path
      fillRule="evenodd"
      d="M12.197.862a.667.667 0 0 1 .719-.147l1.666.666c.291.117.462.42.41.729l-.333 2a.667.667 0 0 1-.658.557h-.666v.667a.667.667 0 0 1-.667.666h-.667v.667c0 .177-.07.346-.195.471L9.161 9.783A4.333 4.333 0 1 1 6.218 6.84L12.198.862Zm-1.529 5.529-2.12 2.12a4.358 4.358 0 0 0-1.057-1.058l5.338-5.337.76.304-.152.914h-.769a.667.667 0 0 0-.667.666v.667h-.666a.667.667 0 0 0-.667.667V6.39ZM5.001 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
      clipRule="evenodd"
    />
  </SVGIcon>
);
